export default 'https://tme.understood.org/assets/Light_Texture00.6228f1a8.jpg'